import { lazy } from 'react';

let SVGComponents = {};

SVGComponents['Home'] = lazy(() => import('root/components/Icon/SVGDeposit'));

export default SVGComponents;
